module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-question"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "question-modal-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('span', {
    staticClass: "question-modal-btn-close material-icons",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body question-custom-body"
  }, [_c('p', {
    staticClass: "question-content"
  }, [_vm._v(_vm._s(_vm.content))])]), _c('div', {
    staticClass: "modal-footer question-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "question-btn-continue btn",
    on: {
      "click": function($event) {
        return _vm.validateDelete()
      }
    }
  }, [_vm._v("Xác nhận")])])]), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('a', {
    staticClass: "question-btn-back btn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Hủy yêu cầu")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db717364","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exercise/popupLock.vue
// module id = 1655
// module chunks = 0